import faker from 'faker';
import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _favoriteControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    displayId: {
      name: 'รหัส',
      width: '10rem',
    },
    firstName: {
      name: 'ชื่อ - นามสกุล',
      width: '1fr',
    },
    gender: {
      name: 'เพศ',
      width: '3rem',
    },
    'creatorGroup.name': {
      name: 'ประเภท',
      width: '10rem',
    },
    honouredYear: {
      name: 'ประจำปี',
      width: '6rem',
    },
    'handicraftType.name': {
      name: 'กลุ่มงาน',
      width: '8rem',
    },
    groupAddress: {
      key: 'province',
      name: 'จังหวัดที่อยู่',
      width: '8rem',
      filter: (val: any) => ((val.province) ? val.province.name : ''),
    },
    lastUpdatedBy: {
      name: 'ผู้แก้ไขข้อมูล',
      width: '10rem',
    },
    isDead: {
      name: 'สถานะ',
      width: '6rem',
    },
    updatedAt: {
      key: 'updatedAt',
      name: 'แก้ไขล่าสุด',
      width: '9rem',
      class: 'text-right',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDate();
      },
    },
    _secondaryControls: {
      width: '5rem',
      class: 'text-right',
    },
    images: {
      name: 'รูป',
      width: '5rem',
    },
  },
  columns: ['_primaryControls', '_favoriteControls', '_increment', 'displayId', 'firstName',
    'gender', 'creatorGroup.name', 'honouredYear', 'handicraftType.name',
    'groupAddress', 'isDead', 'updatedAt', '_secondaryControls'],
  sortable: ['firstName', 'gender', 'type', 'updatedAt', 'honouredYear'],
  grids: ['_primaryControls', 'images', 'firstName', 'type', 'creatorGroup.name', '_favoriteControls', '_secondaryControls'],
};
